import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Input, Table, Button, Icon, Select, Tabs, InputNumber, notification, Switch } from 'antd';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Highlighter from 'react-highlight-words';
import './FnbAdditionalItemModal.css';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';

const { Text } = Typography;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

@inject(
    'CmsLanguageStore',
    'webSettingStore',
    'FnbAdditionalItemStore'
)
@observer
class FnbAdditionalItemModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
        this.props.CmsLanguageStore.getActives();
        this.props.webSettingStore.getData();
    }

    // ON CHANGE

    optionNameEnglishOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setOptionNameEnglish(e.target.value);
    }

    optionNameChineseOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setOptionNameChinese(e.target.value);
    }

    optionNameChineseTraditionalOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setOptionNameChineseTraditional(e.target.value);
    }

    optionNameThaiOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setOptionNameThai(e.target.value);
    }

    optionNameJapaneseOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setOptionNameJapanese(e.target.value);
    }

    optionNameArabicOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setOptionNameArabic(e.target.value);
    }

    controlTypeOnChange = (value) => {
        this.props.FnbAdditionalItemStore.setControlType(value);
    }

    subItemNameEnglishOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setSubItemNameEnglish(e.target.value);
    }

    subItemNameChineseOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setSubItemNameChinese(e.target.value);
    }

    subItemNameChineseTraditionalOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setSubItemNameChineseTraditional(e.target.value);
    }

    subItemNameThaiOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setSubItemNameThai(e.target.value);
    }

    subItemNameJapaneseOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setSubItemNameJapanese(e.target.value);
    }

    subItemNameArabicOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setSubItemNameArabic(e.target.value);
    }

    priceOnChange = (value) => {
        this.props.FnbAdditionalItemStore.setPrice(value);
    }

    maxNumberOnChange = (value) => {
        this.props.FnbAdditionalItemStore.setMaxNumber(value);
    }

    // ON Search

    fnbItemOnSearch = () => {
        this.props.FnbAdditionalItemStore.setItemSearchValue('');
        this.props.FnbAdditionalItemStore.searchItem();
        this.props.FnbAdditionalItemStore.setShowFnbAdditinalItemSearchModal(true);
    }

    // ON CLICK

    createOrUpdateFnbAdditionalItemDetailOnClick = () => {
        const { activeLanguages } = this.props.CmsLanguageStore;
        this.props.FnbAdditionalItemStore.createOrUpdateFnbAdditionalItemDetail(activeLanguages);
    }

    initUpdateFnbAdditionalItemDetailOnClick = (fnbAdditionalItemDetailId) => {
        const { activeLanguages } = this.props.CmsLanguageStore;
        this.props.FnbAdditionalItemStore.initUpdateFnbAdditionalItemDetail(fnbAdditionalItemDetailId, activeLanguages);
    }

    cancelFnbAdditionalItemDetailOnClick = () => {
        const { activeLanguages } = this.props.CmsLanguageStore;
        this.props.FnbAdditionalItemStore.cancelFnbAdditionalItemDetail(activeLanguages);
    }

    deleteFnbAdditionalItemDetailOnClick = (fnbAdditionalItemDetailId) => {
        const { activeLanguages } = this.props.CmsLanguageStore;
        this.props.FnbAdditionalItemStore.deleteFnbAdditionalItemDetail(fnbAdditionalItemDetailId, activeLanguages);
    }

    createOrUpdateFnbAdditionalItemOnClick = () => {
        const { t } = this.props;
        const { fnbAdditionalItemId } = this.props.FnbAdditionalItemStore;
        if (fnbAdditionalItemId === 0) {
            this.props.FnbAdditionalItemStore.createFnbAdditionalItem().then(isSuccess => {
                if (isSuccess) {
                    notification['success']({
                        message: t('Success'),
                        description: t('FnB Additional Item has been successfully created.'),
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: t('Error'),
                        description: t('Unexpected issue occured. Please contact your administrator.'),
                        duration: 3
                    });
                }
            });
        } else {
            this.props.FnbAdditionalItemStore.updateFnbAdditionalItem().then(isSuccess => {
                if (isSuccess) {
                    notification['success']({
                        message: t('Success'),
                        description: t('FnB Additional Item has been successfully updated.'),
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: t('Error'),
                        description: t('Unexpected issue occured. Please contact your administrator.'),
                        duration: 3
                    });
                }
            });
        }
    }

    // ON TAB CLICK

    tabOptionNameOnTabClick = (key) => {
        this.props.FnbAdditionalItemStore.setTabOptionNameActiveKey(key);
    }

    tabSubItemNameOnTabClick = (key) => {
        this.props.FnbAdditionalItemStore.setTabSubItemNameActiveKey(key);
    }

    // TABLE SETTING

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('Sub Item Name'),
                dataIndex: 'subItemName',
                key: 'subItemName',
                ...this.getColumnSearchProps('subItemName')
            },
            {
                title: t('Price'),
                dataIndex: 'price',
                key: 'price',
            },
            {
                title: t('Action'),
                dataIndex: 'fnbAdditionalItemDetailId',
                key: 'action',
                render: fnbAdditionalItemDetailId => (
                    <span>
                        <Button onClick={() => this.initUpdateFnbAdditionalItemDetailOnClick(fnbAdditionalItemDetailId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <EditIcon style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button>
                        <Button onClick={() => this.deleteFnbAdditionalItemDetailOnClick(fnbAdditionalItemDetailId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: '#DC004E', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
            const { t } = this.props;
            return (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            this.searchInput = node
                        }}
                        placeholder={`${t('Search')} ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type='primary'
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon='search'
                        size='small'
                        style={{ width: 90, marginRight: 8 }}
                    >
                        {t('Search')}
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                        {t('Reset')}
                    </Button>
                </div>
            )
        },
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    isLanguageIdActive = (languageId) => {
        const { activeLanguages } = this.props.CmsLanguageStore;

        if (activeLanguages) {
            const language = activeLanguages.find(fi => fi.id === languageId);
            if (language) {
                return true;
            }
        }

        return false;
    }

    render() {
        const { t } = this.props;
        const { activeLanguages } = this.props.CmsLanguageStore;

        const { data: webSettting } = this.props.webSettingStore;

        const {
            fnbAdditionalItemDetails,
            fnbTaskName,
            tabOptionNameActiveKey,
            optionNameEnglish,
            optionNameChinese,
            optionNameChineseTraditional,
            optionNameThai,
            optionNameJapanese,
            optionNameArabic,
            isRequired,
            controlType,
            maxNumber,
            tabSubItemNameActiveKey,
            subItemNameEnglish,
            subItemNameChinese,
            subItemNameChineseTraditional,
            subItemNameThai,
            subItemNameJapanese,
            subItemNameArabic,
            price,
            itemDetailTextButton,
            itemTextButton,
            fnbAdditionalItemModalLoading,
            optionNameLangs,
            subItemNameLangs,
        } = this.props.FnbAdditionalItemStore;

        let addOrUpdateItemDetailDisable = false;
        const englishLang = subItemNameLangs.find(l => l.langId === 1);
        if (!englishLang || englishLang.name.trim() === '') {
            addOrUpdateItemDetailDisable = true;
        }

        let addOrUpdateItemDisable = false;
        if (fnbTaskName === '' || optionNameEnglish === '' || fnbAdditionalItemDetails.length === 0) {
            addOrUpdateItemDisable = true;
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            <Spin spinning={fnbAdditionalItemModalLoading}>
                                <Row className='fnbadditionalitemmodal-row-container'>
                                    <Col span={24} className='fnbadditionalitemmodal-col'>
                                        <Row>
                                            <Col span={8} className='fnbadditionalitemmodal-col-label'>
                                                <Text className='fnbadditionalitemmodal-text-label'>{t('FnB Item')}<Text className='fnbadditionalitemmodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='fnbadditionalitemmodal-col-input'>
                                                <Search
                                                    placeholder={t('search item')}
                                                    value={fnbTaskName}
                                                    onSearch={this.fnbItemOnSearch}
                                                    enterButton
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='fnbadditionalitemmodal-col'>
                                        <Row>
                                            <Col span={8} className='fnbadditionalitemmodal-col-label'>
                                                <Text className='fnbadditionalitemmodal-text-label'>{t('Control Type')}<Text className='fnbadditionalitemmodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16}>
                                                <Row>
                                                    <Col span={24} className='fnbadditionalitemmodal-col-input'>
                                                        <Select className='fnbadditionalitemmodal-select' value={controlType} onChange={this.controlTypeOnChange}>
                                                            <Option key='check' value='check'>{t('Multi Check List')}</Option>
                                                            <Option key='radio' value='radio'>{t('Radio List')}</Option>
                                                        </Select>
                                                    </Col>
                                                    <Col span={24} className='fnbadditionalitemmodal-col-input-switch'>
                                                        <Switch checkedChildren={t('Yes')} unCheckedChildren={t('No')} checked={isRequired} onChange={(e) => this.props.FnbAdditionalItemStore.setIsRequired(e)} className='fnbadditionalitemmodal-switch-all' />
                                                        <Text className='fnbadditionalitemmodal-text-switch-all'>{t('Compulsory')}</Text>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <React.Fragment>
                                        {
                                            controlType === 'check'
                                                ?
                                                <Col span={24} className='fnbadditionalitemmodal-col'>
                                                    <Row>
                                                        <Col span={8} className='fnbadditionalitemmodal-col-label'>
                                                            <Text className='fnbadditionalitemmodal-text-label'>{t('Maximum Selection')}<Text className='fnbadditionalitemmodal-text-label-mandatory'>*</Text></Text>
                                                        </Col>
                                                        <Col span={16} className='fnbadditionalitemmodal-col-input'>
                                                            <InputNumber
                                                                className='fnbadditionalitemmodal-inputnumber-short'
                                                                min={1}
                                                                value={maxNumber}
                                                                onChange={this.maxNumberOnChange}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                :
                                                null
                                        }
                                    </React.Fragment>
                                    <Col span={24} className='fnbadditionalitemmodal-col'>
                                        <Row>
                                            <Col span={8} className='fnbadditionalitemmodal-col-label-tabs'>
                                                <Text className='fnbadditionalitemmodal-text-label'>{t('Option Name')}<Text className='fnbadditionalitemmodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='fnbadditionalitemmodal-col-input'>
                                                <Tabs activeKey={tabOptionNameActiveKey} onTabClick={this.tabOptionNameOnTabClick}>
                                                    {
                                                        activeLanguages.map(lang => {
                                                            const langItem = optionNameLangs.find(x => x.langId === lang.id);

                                                            if (!langItem) return null;

                                                            return (
                                                                <TabPane tab={lang.originalName} key={lang.id}>
                                                                    <Input
                                                                        className='fnbadditionalitemmodal-input'
                                                                        value={langItem.name}
                                                                        onChange={(e) => {
                                                                            const newValue = e.target.value;
                                                                            this.props.FnbAdditionalItemStore.setOptionNameLang(lang.id, newValue);
                                                                        }}
                                                                    />
                                                                </TabPane>
                                                            );
                                                        })
                                                    }
                                                </Tabs>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='fnbadditionalitemmodal-col-subitem'>
                                        <Row>
                                            <Col span={24} className='fnbadditionalitemmodal-col-title'>
                                                <Text className='fnbadditionalitemmodal-text-title'>{t('Sub Item List')}</Text>
                                            </Col>
                                            <Col span={24} className='fnbadditionalitemmodal-col'>
                                                <Table columns={this.getColumns()} dataSource={fnbAdditionalItemDetails} />
                                            </Col>
                                            <Col span={24} className='fnbadditionalitemmodal-col'>
                                                <Row>
                                                    <Col span={8} className='fnbadditionalitemmodal-col-label-tabs'>
                                                        <Text className='fnbadditionalitemmodal-text-label'>{t('Sub Item Name')}<Text className='fnbadditionalitemmodal-text-label-mandatory'>*</Text></Text>
                                                    </Col>
                                                    <Col span={16} className='fnbadditionalitemmodal-col-input'>
                                                        <Tabs activeKey={tabSubItemNameActiveKey} onTabClick={this.tabSubItemNameOnTabClick}>
                                                            {
                                                                activeLanguages.map(lang => {
                                                                    const langItem = subItemNameLangs.find(x => x.langId === lang.id);
                                                                    if (!langItem) return null;

                                                                    return (
                                                                        <TabPane tab={lang.originalName} key={lang.id}>
                                                                            <Input
                                                                                className="fnbadditionalitemmodal-input"
                                                                                value={langItem.name}
                                                                                onChange={(e) => {
                                                                                    const newValue = e.target.value;
                                                                                    this.props.FnbAdditionalItemStore.setSubItemNameLang(lang.id, newValue);
                                                                                }}
                                                                            />
                                                                        </TabPane>
                                                                    );
                                                                })
                                                            }
                                                        </Tabs>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col span={24} className='fnbadditionalitemmodal-col'>
                                                <Row>
                                                    <Col span={8} className='fnbadditionalitemmodal-col-label'>
                                                        <Text className='fnbadditionalitemmodal-text-label'>{t('Price')}<Text className='fnbadditionalitemmodal-text-label-mandatory'>*</Text></Text>
                                                    </Col>
                                                    <Col span={16} className='fnbadditionalitemmodal-col-input'>
                                                        <InputNumber
                                                            className='fnbadditionalitemmodal-inputnumber'
                                                            value={price}
                                                            min={0}
                                                            onChange={this.priceOnChange}
                                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                        /> &nbsp;&nbsp;
                                                        <Text className='fnbadditionalitemmodal-text-currency'>
                                                            {webSettting ? webSettting.currencyCode : t('No Currency')}
                                                        </Text>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col span={24} className='fnbadditionalitemmodal-col'>
                                                <Row>
                                                    <Col span={8} />
                                                    <Col span={16} className='fnbadditionalitemmodal-col-input'>
                                                        <Button type='primary' disabled={addOrUpdateItemDetailDisable} className='fnbadditionalitemmodal-button-subitem' onClick={this.createOrUpdateFnbAdditionalItemDetailOnClick}>{t(itemDetailTextButton)}</Button>
                                                        <Button className='fnbadditionalitemmodal-button-subitem' onClick={this.cancelFnbAdditionalItemDetailOnClick}>{t('Cancel')}</Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='fnbadditionalitemmodal-col-button'>
                                        <Button disabled={addOrUpdateItemDisable} type='primary' className='fnbadditionalitemmodal-button' onClick={this.createOrUpdateFnbAdditionalItemOnClick}>{t(itemTextButton)}</Button>
                                    </Col>
                                </Row>
                            </Spin >
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(FnbAdditionalItemModalPage);